export class GetBorrowerStatuses {
  static readonly type = '[BorrowerStatuses] GetBorrowerStatuses';
  constructor() {}
}
